const Footer: React.FC = () => (
  <div className="flex w-full items-center justify-center border-t border-gray-300 bg-white p-2 text-center sm:min-h-[56px] md:px-24">
    <span className="text-xs text-primary sm:text-sm">
      &copy; Copyright 2016-{new Date().getFullYear()} - Rede Vistorias
      Franchising S/A - CNPJ: 25.005.259/0001-56
    </span>
  </div>
)

export default Footer
